import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import InfoCircle from "../../../../../media/images/icons/info-circle";
import { Link } from "react-router-dom";
import ArrowTickLeft from "../../../../../media/images/icons/arrow-tick-left";
import LampSVG from "../../../../../media/images/icons/lamp";
import LampFill from "../../../../../media/images/icons/lamp-fill";
import PlayFillIcon from "../../../../../media/images/icons/play-fill";

export default function InfoBox() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        borderRadius: "16px",
        borderColor: "primary.main",
        borderWidth: "1px",
        borderStyle: "solid",
        padding: "16px 8px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: "4px",
        }}
      >
        <InfoCircle color={theme.palette.primary.main} />
        <Typography
          sx={{
            color: "primary.main",
          }}
        >
          در صورت نیاز به راهنما درباره بخش‌ها و امکانات بازارگاه می‌توانید
          راهنمای جامع بازارگاه یا آموزش‌های ویدئویی را مشاهده‌کنید:
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <Link
          to={"/"}
          style={{
            padding: "8px",
            borderRadius: "16px",
            flex: "1",
            borderWidth: "2px",
            borderColor: theme.palette.secondary.main,
            borderStyle: "solid",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <LampFill color={theme.palette.secondary.main} />

            <Typography
              sx={{
                fontSize: "12px",
                color: "secondary.main",
                fontWeight: "600",
              }}
            >
              راهنمای جامع بازارگاه
            </Typography>
          </Box>
          <ArrowTickLeft size={20} color={theme.palette.secondary.main} />
        </Link>
        <Link
          to={"/"}
          style={{
            padding: "8px",
            borderRadius: "16px",
            flex: "1",
            borderWidth: "2px",
            borderColor: theme.palette.error.main,
            borderStyle: "solid",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <PlayFillIcon color={theme.palette.error.main} />

            <Typography
              sx={{
                fontSize: "12px",
                color: "error.main",
                fontWeight: "600",
              }}
            >
              آموزش‌های ویدئویی{" "}
            </Typography>
          </Box>
          <ArrowTickLeft size={20} color={theme.palette.error.main} />
        </Link>
      </Box>
    </Box>
  );
}
